export default __webpack_public_path__ + "static/media/slider-hero.18cc5561.png";